import '.k{list-style-type:none;}.ssr-plugin'
import '.l{padding:0px;}.ssr-plugin'
import useMediaQuery from '@app/util/useMediaQuery'
import { NavBarMobile } from '@app/components/blocks/navbar/blocks/NavBar.mobile'
import { NavBarDesktop } from '@app/components/blocks/navbar/blocks/NavBar.desktop'
import { FC, useState } from 'react'
import { fullName } from '@app/util/helpers'
import { useUserContext } from '@app/util/hooks/useUserContext'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { Image } from '@app/components/core/image/Image'
import { HoverTabs } from '@app/components/core/tabs/HoverTabs'
import { Drawer } from '@app/components/blocks/drawer/Drawer'
import { TextLink } from '@app/components/core/link/TextLink'
import { styled } from 'inlines'
import { SignupFormModal } from './SignupFormModal'
import { useTranslations } from '@i18n/useLanguage'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'

export const TopNavBar: FC = () => {
  const isMobile = useMediaQuery()
  const { user, isLoading } = useUserContext()
  const tenant = useTenantContext()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const t = useTranslations().app.steunpuntAmsterdam
  const [currentPath] = useLocation()

  const userName = user ? fullName(user) : undefined

  return isMobile ? (
    <NavBarMobile
      userName={userName}
      avatar={user?.avatar?.src}
      isLoading={isLoading}
      onMenuOpen={() => setIsMenuOpen(true)}
      logo={
        <Image
          src={tenant.logoUrl}
          alt={`${tenant.title} Logo`}
          resizeWidth={123}
          style={{ maxWidth: '320px', width: '100%' }}
        />
      }
    >
      <Drawer
        setOpen={setIsMenuOpen}
        open={isMenuOpen}
        title={tenant.title}
        side="left"
      >
        <styled.ul className="k l"
          style={{

            '& li': {
              marginBottom: '1rem',
            },
          }}
        >
          <li onClick={() => setIsMenuOpen(false)}>
            <TextLink to={pages.home + '#over-steunpunt'}>
              {t.nav.about}
            </TextLink>
          </li>
          <li onClick={() => setIsMenuOpen(false)}>
            <TextLink to={pages.knowledgeHub}>{t.nav.knowledgeHub}</TextLink>
          </li>
          <li onClick={() => setIsMenuOpen(false)}>
            <TextLink to={pages.events}>{t.nav.agenda}</TextLink>
          </li>
          <li onClick={() => setIsMenuOpen(false)}>
            <TextLink to={pages.home + '#contact'}>{t.nav.contact}</TextLink>
          </li>
        </styled.ul>
      </Drawer>
    </NavBarMobile>
  ) : (
    <NavBarDesktop
      logo={
        <Image
          src={tenant.logoUrl}
          alt={`${tenant.title} Logo`}
          style={{ maxWidth: '320px', width: '100%' }}
        />
      }
    >
      <HoverTabs.Group>
        <HoverTabs.Tab
          label={t.nav.about}
          to={pages.home + '#over-steunpunt'}
          active={currentPath.includes(pages.home + '#over-steunpunt')}
        />
        <HoverTabs.Tab
          label={t.nav.knowledgeHub}
          to={pages.knowledgeHub}
          active={currentPath.includes(pages.knowledgeHub)}
        />
        <HoverTabs.Tab
          label={t.nav.agenda}
          to={pages.events}
          active={currentPath.includes(pages.events)}
        />
        <HoverTabs.Tab
          label={t.nav.contact}
          to={pages.home + '#contact'}
          active={currentPath.includes(pages.home + '#contact')}
        />
      </HoverTabs.Group>

      <SignupFormModal />
    </NavBarDesktop>
  )
}
